var exports = {
  "D": "xf0b3b88a--c7b8d5--land-status",
};

module.exports = exports;
